var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCall24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_call24x24",
    transform: "translate(-2.999 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M15.643,13.05l-2.471-2.477a1.286,1.286,0,0,0-1.817.035l-1.244,1.245-.245-.137a12.387,12.387,0,0,1-3-2.169A12.486,12.486,0,0,1,4.7,6.54c-.046-.084-.089-.164-.134-.241L5.4,5.463,5.81,5.05A1.293,1.293,0,0,0,5.843,3.23L3.373.755A1.285,1.285,0,0,0,1.556.787l-.7.7.019.019A4.039,4.039,0,0,0,.306,2.523,4.215,4.215,0,0,0,.05,3.552C-.277,6.266.96,8.741,4.314,12.1c4.637,4.647,8.373,4.3,8.533,4.279a4.166,4.166,0,0,0,1.029-.26,4.01,4.01,0,0,0,1.009-.572l.015.013.706-.692a1.294,1.294,0,0,0,.037-1.821Z",
    transform: "translate(3 2.606)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCall24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_call24x24.e2cc3326f60248e19983c0ef06980ce1.svg";